import React from "react";
import AppDialog from "./AppDialog";

interface AppConfirmDialogProps {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const AppConfirmDialog: React.FC<AppConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  busy = false,
  onCancel,
  onConfirm
}) => (
  <AppDialog
    open={open}
    title={title}
    onClose={busy ? () => undefined : onCancel}
    footer={
      <>
        <button className="bg-gray-200 text-gray-800 px-4 py-2 rounded" onClick={onCancel} disabled={busy}>
          {cancelLabel}
        </button>
        <button
          className={`${destructive ? "bg-red-600 hover:bg-red-700" : "bg-blue-600 hover:bg-blue-700"} text-white px-4 py-2 rounded`}
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? "Working..." : confirmLabel}
        </button>
      </>
    }
  >
    <div className="text-gray-700">{message}</div>
  </AppDialog>
);

export default AppConfirmDialog;
